module.exports = "precision highp float;\n#define GLSLIFY 1\n\nvarying vec3 vColor;\n\nvoid main() {\n  gl_FragColor = vec4(vColor, 1.0);\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./~/glslify-loader!/Users/songseunggeun/voxeline/engine/shaders/object.frag
 ** module id = 775
 ** module chunks = 0
 **/